import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Loading } from './../../../components/includes/loading';
import { Buttons } from './../../../components/includes/container';
import { InputTextField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { isPasswordValid } from './../../../utilities/utils';
import { UserService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (!values.new_password) {
    errors.new_password = VALIDATION.required;
  } else if( !isPasswordValid(values.new_password) ){
    errors.new_password = VALIDATION.password;
  }

  if (!values.confirm_password) {
    errors.confirm_password = VALIDATION.required;
  } else if (values.confirm_password !== values.new_password) {
    errors.confirm_password = VALIDATION.mismatched_password;
  }

  return errors;

}

class Password extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false
    };
  }

  /*
  ** @Service
  ** @Description: Update password
  */

  _Update = (values) => {

    // @State
    this.setState({ loading: true });

    // @Merge
    // @Description: Merge form and id user
    let toSend = Object.assign({ id: this.props.id }, values);

    // @Service
    UserService.password(toSend).then((response) => {

      // @State
      this.setState({ loading: false });

      // @Event
      // @Description: Close modal form
      this.props.onSuccess();

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'success', message: response.message });

    }).catch((error) => {

      // @State
      this.setState({ loading: false });

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Submit
  ** @Description: Submit password form
  */

  handleSubmitForm = (values) => {

    this._Update(values);

  }

  render() {

    const { loading } = this.state;
    const { handleSubmit } = this.props;

    return(

      <div>

        { loading && (
          <Loading variant="secondary"/>
        )}

        <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Field
                  name="new_password"
                  component={ InputTextField }
                  label="Nueva contraseña"
                  type="password"
                  required
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                  name="confirm_password"
                  component={ InputTextField }
                  label="Confirmar contraseña"
                  type="password"
                  required
              />
            </Grid>
            <Grid item xs={12}>
              <Buttons align="right">
                <Btn aria-label="Confirmar" icon="save" color="success" type="submit">
                  Confirmar
                </Btn>
              </Buttons>
            </Grid>
          </Grid>

        </form>

      </div>

    )
  }
}

Password = reduxForm({
  form: 'Password',
  validate,
  enableReinitialize: true
})(Password);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Password);
